export enum EnabledOption {
  ENABLED = 'enabled',
  DISABLED = 'disabled',
}

// The order of the enum is important for the sorting in the UI
export enum Lifecycle {
  ACTIVE = 'ACTIVE',
  DRAFT = 'DRAFT',
  PENDING = 'PENDING',
  SUSPENDED = 'SUSPENDED',
  DEACTIVATED = 'DEACTIVATED',
}

export const DATAOWNER_CREATE_LIFECYCLE_OPTIONS = [
  Lifecycle.ACTIVE,
  Lifecycle.DRAFT,
  Lifecycle.PENDING,
] as const;

// The order of the enum is important for the sorting in the UI
export enum OrgRegistrationStatus {
  ACTIVE = 'ACTIVE',
  LIQUIDATING = 'LIQUIDATING',
  CEASED = 'CEASED',
  BANKRUPT = 'BANKRUPT',
  NOT_APPLICABLE = 'NOT_APPLICABLE',
  UNKNOWN = 'UNKNOWN',
}
